// import external dependencies
// import "jquery";

// Import everything from autoload
// import './autoload/**/*'

import "./components/modal";
import "./components/info";
import "./components/video-modal";
import "./components/image-modal";
import "./components/btnLoader";
import "./components/specialSelect";
import "./components/hotelGrid";

import moment from "moment";
import "moment/locale/he";
import "moment/locale/ar";

import { $t } from "./i18n";
import Vue from "vue";
Vue.prototype.$t = $t;

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";
import singleSite from "./routes/singleSite";
import taxCountry from "./routes/taxCountry";
import taxHotel from "./routes/taxHotel";
import pageTemplateTemplatePersonal from "./routes/pageTemplateTemplatePersonal";
import pageTemplateTemplateAbout from "./routes/pageTemplateTemplateAbout";
import pageTemplateTemplateGallery from "./routes/pageTemplateTemplateGallery";
import pageTemplateTemplateLoginAgent from "./routes/pageTemplateTemplateLoginAgent";
import pageTemplateTemplateLoginRegular from "./routes/pageTemplateTemplateLoginRegular";
import pageTemplateTemplateSnowSupport from "./routes/pageTemplateTemplateSnowSupport";
import pageTemplateTemplateQuiz from "./routes/pageTemplateTemplateQuiz";
import pageTemplateTemplateVacationPlan from "./routes/pageTemplateTemplateVacationPlan";
import pageTemplateTemplateOrderVacation from "./routes/pageTemplateTemplateOrderVacation";
import pageTemplateTemplateAdvancedCountry from "./routes/pageTemplateTemplateAdvancedCountry";
import pageTemplateTemplateFaq from "./routes/pageTemplateTemplateFaq";
import pageTemplateTemplateSummerLobby from "./routes/pageTemplateTemplateSummerLobby";

export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_DESKTOP = 1025;

window.$ = window.jQuery;

moment.locale(
  jQuery("html")
    .attr("lang")
    .split("-")[0]
);

const pageTemplateTemplateSendQuote = window.sendQuoteController || {};

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  pageTemplateTemplateAdvancedCountry,
  pageTemplateTemplatePersonal,
  pageTemplateTemplateAbout,
  pageTemplateTemplateGallery,
  pageTemplateTemplateLoginAgent,
  pageTemplateTemplateLoginRegular,
  pageTemplateTemplateSnowSupport,
  pageTemplateTemplateQuiz,
  pageTemplateTemplateVacationPlan,
  pageTemplateTemplateSendQuote,
  pageTemplateTemplateOrderVacation,
  pageTemplateTemplateFaq,
  singleSite,
  taxCountry,
  taxHotel,
  pageTemplateTemplateSummerLobby
});
// let width = screen.width;
// let iframe = document.getElementById('yFrame');
// if(width < 550){
//   iframe.style.width = '320px';
// }
// Load Events
jQuery(document).ready(() => routes.loadEvents());
